import React from 'react';
import styles from './index.module.scss';

const DmcaPage = () => {
  return (
    <main className={styles.container}>
      <section>
        <h1>BF Island DMCA Copyright Policy</h1>
        <p>Effective Date: January 30, 2026</p>
        <br />
        <p>
          This DMCA Copyright Policy applies to your use of BF Island mobile
          application, services, content, features, and properties
          (collectively, the &quot;BF Island&quot;). BF Island is provided by
          BuzzFeed Media Enterprises, Inc., or the relevant BuzzFeed subsidiary
          or affiliate company (&quot;BuzzFeed&quot;, &quot;we&quot;,
          &quot;us&quot;, or &quot;our&quot;). Please read this User Agreement
          carefully as it sets forth the legally binding terms and conditions
          for your use of BF Island.
        </p>
        <h2>Preamble</h2>
        <p>
          AS STATED IN OUR USER AGREEMENT, ALL MEDIA, WHICH INCLUDES YOUR
          OUTPUTS, ARE OWNED SOLELY BY YOU SUBJECT TO THE LIMITED USE LICENSE
          YOU GRANTED TO US. AS SUCH, YOU ARE SOLELY RESPONSIBLE FOR ENSURING
          THAT YOU DO NOT VIOLATE THIRD PARTY RIGHTS SUCH AS COPYRIGHT. WE HAVE
          ADOPTED THE FOLLOWING GENERAL POLICY TOWARDS REPORTS OF COPYRIGHT
          INFRINGEMENT.
        </p>
        <h2>Submitting a Claim</h2>
        <p>
          The easiest way to submit a DMCA claim is via our form here:{' '}
          <a
            href="https://www.buzzfeed.com/about/contact"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.buzzfeed.com/about/contact
          </a>
          . Otherwise, please read on.
        </p>
        <p>
          The address of the Designated Agent to Receive Notification of Claimed
          Infringement (&quot;Designated Agent&quot;) is listed at the end of
          this policy.
        </p>
        <h2>Alternative Procedure for Reporting Copyright Infringement</h2>
        <ol>
          <li>
            A physical or electronic signature of a person authorized to act on
            behalf of the owner of the copyright that has been allegedly
            infringed;
          </li>
          <li>Identification of works or materials being infringed; </li>
          <li>
            Identification of the material that is claimed to be infringing
            including information regarding the location of the infringing
            materials that the copyright owner seeks to have removed, with
            sufficient detail so that BuzzFeed is capable of finding and
            verifying its existence;
          </li>
          <li>
            Contact information about the notifier including address, telephone
            number and, if available, e-mail address;
          </li>
          <li>
            A statement that the notifier has a good faith belief that the
            material is not authorized by the copyright owner, its agent, or the
            law;
          </li>
          <li>
            A statement made under penalty of perjury that the information
            provided is accurate and the notifying party is authorized to make
            the complaint on behalf of the copyright owner.
          </li>
        </ol>
        <h3>
          Once Proper Bona Fide Infringement Notification is Received by the
          Designated Agent:
        </h3>

        <p>It is BuzzFeed&rsquo;s policy:</p>
        <ol>
          <li>to investigate the notification;</li>
          <li>to determine the appropriate action;</li>
          <li> to remove or disable access to the infringing material;</li>
          <li>
            {' '}
            to notify the content provider, member or user that it has removed
            or disabled access to the material; and
          </li>
          <li>
            that repeat offenders will have the infringing material removed from
            the system and that BuzzFeed will terminate such content
            provider&rsquo;s, member&rsquo;s or user&rsquo;s access to the
            service.
          </li>
        </ol>
        <h3>Procedure to Supply a Counter-Notice to the Designated Agent:</h3>
        <p>
          If the content provider, member or user believes that the material
          that was removed or to which access was disabled is either not
          infringing, or the content provider, member or user believes that it
          has the right to post and use such material from the copyright owner,
          the copyright owner&rsquo;s agent, or pursuant to the law, the content
          provider, member or user must send a counter-notice containing the
          following information to the Designated Agent listed below:
        </p>
        <ol>
          <li>
            A physical or electronic signature of the content provider, member
            or user;
          </li>
          <li>
            Identification of the material that has been removed or to which
            access has been disabled and the location at which the material
            appeared before it was removed or disabled;
          </li>
          <li>
            A statement that the content provider, member or user has a good
            faith belief that the material was removed or disabled as a result
            of mistake or a misidentification of the material; and
          </li>
          <li>
            Content provider&rsquo;s, member&rsquo;s or user&rsquo;s name,
            address, telephone number, and, if available, e-mail address and a
            statement that such person or entity consents to the jurisdiction of
            the Federal Court for the judicial district in which the content
            provider&rsquo;s, member&rsquo;s or user&rsquo;s address is located,
            or if the content provider&rsquo;s, member&rsquo;s or user&rsquo;s
            address is located outside the United States, for any judicial
            district in which BuzzFeed is located, and that such person or
            entity will accept service of process from the person who provided
            notification of the alleged infringement.
          </li>
        </ol>
        <p>
          If a counter-notice is received by the Designated Agent, BuzzFeed may
          send a copy of the counter-notice to the original complaining party
          informing that person that it may replace the removed material or
          cease disabling it in 10 business days. Unless the copyright owner
          files an action seeking a court order against the content provider,
          member or user, the removed material may be replaced or access to it
          restored in 10 to 14 business days or more after receipt of the
          counter-notice, at BuzzFeed&rsquo;s discretion.
        </p>
        <p>
          Please contact the Designated Agent to Receive Notification of Claimed
          Infringement for BuzzFeed at copyrightagent@buzzfeed.com or at:
        </p>
        <p>
          BuzzFeed
          <br />
          Attn: Copyright Agent
          <br />
          50 West 23rd Street, 6th Floor
          <br />
          New York City, NY 10010
        </p>
      </section>
    </main>
  );
};
export default DmcaPage;
